import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import consultingImg from '../assets/img/product-consulting.png';
import automationImg from '../assets/img/automation-of-manual-asks.png';
import networkImg from '../assets/img/strategic-network-planning.png';
import trainingImg from '../assets/img/training-and-support.jpg';
import whyChooseImg from '../assets/img/why-choose-us-services.png';

function ServicesPage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [hash]);

  return (
    <>
      <div className="hero-header sec-padding inner-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <h1>Professional Services</h1>
              <p>Expert DDI consulting and support to complement the Netwatch platform</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid sec-padding">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8">
              <div className="services-promo text-center">
                <span className="section-subtitle">Product + Services</span>
                <h3 style={{ fontSize: '22px', fontWeight: 600, color: '#1a1a2e', marginBottom: '12px', marginTop: '8px' }}>
                  Looking for a self-service solution?
                </h3>
                <p style={{ color: '#6b7280', marginBottom: '20px' }}>
                  <b>Netwatch</b> provides powerful network monitoring out of the box. Our professional services are here when you
                  need hands-on help, custom implementations, or team training to get the most from your DDI infrastructure.
                </p>
                <Link to="/product" className="btn-primary-gradient">Explore Netwatch</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding colum-reverse" style={{ background: '#f8f9fc' }} id="DDI-Product-Consulting">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Expert Guidance</span>
                <h2 className="head-main after-border">DDI Product Consulting</h2>
                <p>
                  Leverage our deep understanding of leading DDI products to
                  enhance your network management practices. We offer consulting services to help you make
                  the most of your DDI solutions, including:
                </p>
                <ul className="list-simple">
                  <li>Product Configuration and Optimization</li>
                  <li>Best Practices for Deployment and Management</li>
                  <li>Troubleshooting and Problem Resolution</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-5">
              <img src={consultingImg} alt="DDI Product Consulting" />
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding" id="Automation-of-Manual-Tasks">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <img src={automationImg} alt="Automation of Manual Tasks" />
            </div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Efficiency</span>
                <h2 className="head-main after-border">Automation of Manual Tasks</h2>
                <p>
                  Streamline your network management processes with our
                  automation consulting services. We help you identify and implement automation solutions to
                  reduce manual tasks, improve efficiency, and minimize errors. Our services include:
                </p>
                <ul className="list-simple">
                  <li>Process Analysis and Optimization</li>
                  <li>Automation Tool Implementation</li>
                  <li>Workflow Integration and Support</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding colum-reverse" style={{ background: '#f8f9fc' }} id="Strategic-Network-Planning">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Future-ready</span>
                <h2 className="head-main after-border">Strategic Network Planning</h2>
                <p>
                  Plan for the future with confidence by leveraging our strategic
                  network planning services. We provide insights and recommendations to help you:
                </p>
                <ul className="list-simple">
                  <li>Design Scalable Network Architectures</li>
                  <li>Implement Efficient IP Address Management Strategies</li>
                  <li>Prepare for Growth and Technological Changes</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-5">
              <img src={networkImg} alt="Strategic Network Planning" />
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding" id="Training-and-Support">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <img src={trainingImg} alt="Training and Support" />
            </div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Knowledge</span>
                <h2 className="head-main after-border">Training and Support</h2>
                <p>
                  Empower your team with the knowledge and skills they need to
                  manage your DDI infrastructure effectively. Our training and support services include:
                </p>
                <ul className="list-simple">
                  <li>Custom Training Programs</li>
                  <li>On-Demand Technical Support</li>
                  <li>Knowledge Transfer and Best Practices</li>
                </ul>
              </div>
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="container-fluid why-choose-us sec-padding colum-reverse" style={{ background: '#f8f9fc' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <div className="box-offer">
                <span className="section-subtitle">Why Us</span>
                <h2 className="head-main after-border">Why Choose Our Services?</h2>
                <h3 style={{ marginTop: '20px' }}>Expertise</h3>
                <p>Our consultants bring a wealth of knowledge and experience in DDI systems
                  and leading products.</p>
                <h3>Customization</h3>
                <p>We tailor our services to meet your unique needs and challenges.</p>
                <h3>Results-Driven</h3>
                <p>Our focus is on delivering solutions that drive tangible results and
                  enhance your network management capabilities.</p>
              </div>
            </div>
            <div className="col-lg-5">
              <img src={whyChooseImg} alt="Why Choose Our Services" />
            </div>
            <div className="col-lg-1"></div>
          </div>
        </div>
      </div>

      <div className="cta-section text-center">
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <h2>Need a Self-Service Solution?</h2>
          <p>Try Netwatch — our intelligent network monitoring platform that works alongside our professional services.</p>
          <div className="banner-buttons" style={{ justifyContent: 'center' }}>
            <a href="#demo-form" className="btn-primary-gradient">Try Netwatch Free</a>
          </div>
        </div>
      </div>

      <ContactForm
        earlyAccess={true}
        title="Apply for Early Access"
        description="Our MVP launches July–August 2026. We're selecting 5 pilot customers to test Netwatch and help shape its future. Fill out the form below and our team will be in touch."
      />
    </>
  );
}

export default ServicesPage;
